module.exports = __webpack_public_path__ + "img/sobre-01.ca4ea2fd.png";